export const SUPPORTED_COMPONENTS = {
  anchor: 'anchor',
  inventory: 'inventory',
  overview: 'overview',
  header: 'header',
  highlights: 'highlights',
  cta: 'cta',
  anchorItem: 'anchorItem',
  overviewItem: 'overviewItem',
  vin: 'vin',
  opinion: 'opinion',
  verdict: 'verdict',
  links: 'links',
  linksItem: 'linksItem',
  learnMore: 'learnMore',
  bubble: 'bubble',
  dealership: 'dealership',
  dealershipItem: 'dealershipItem',
  answer: 'answer',
  extract: 'extract',
};

export const ALWAYS_RENDERED_COMPONENTS = [SUPPORTED_COMPONENTS.bubble];
